import Tabs from '../../../js/src/__page/tabs';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		Tabs.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
